import { render, staticRenderFns } from "./IrisProgressIndicator.vue?vue&type=template&id=fb98ea8a&"
import script from "./IrisProgressIndicator.vue?vue&type=script&lang=ts&"
export * from "./IrisProgressIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./IrisProgressIndicator.vue?vue&type=style&index=0&id=fb98ea8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports